import { Component, OnInit } from '@angular/core';
import { Call } from 'src/app/models/call.model';
import { ActivatedRoute } from '@angular/router';
import { MgService } from 'src/app/services/mg.service';
import { Item } from 'src/app/models/item.model';

@Component({
  selector: 'app-client-call-details',
  templateUrl: './client-call-details.component.html',
  styleUrls: ['./client-call-details.component.scss']
})
export class ClientCallDetailsComponent implements OnInit {
  public call: Call = new Call();

  constructor(
    private route: ActivatedRoute,
    private api: MgService,
  ) { }

  ngOnInit(): void {
    this.loadCallInfo()
  }

  private loadCallInfo() {
    this.api.getClientCallByIdentifier(this.identifier)
      .subscribe(
        res => {
          this.call = res.data;
        },
        err => {
          console.error(err);
        }
      )
  }

  public get identifier(): string {
    return this.route.snapshot.params['identifier'];
  }

  public newEntry(entry: Item) {
    this.call.items.push(entry);
    setTimeout(() => {
      this.loadCallInfo();
    }, 2000);
  }
}
